import React from "react";

function EditIcon({ className = "", size = 39 }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 39 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#editIconShadow)">
        <rect
          // x="3.75"
          // y="3.75"
          width="90%"
          height="90%"
          rx="3.75"
          fill="#FA9C03"
          // shapeRendering="crispEdges"
        />
        <path
          d="M18 11.2498L20.25 13.4998M16.5 21.7498H22.5M10.5 18.7498L9.75 21.7498L12.75 20.9998L21.4395 12.3103C21.7207 12.029 21.8787 11.6475 21.8787 11.2498C21.8787 10.852 21.7207 10.4706 21.4395 10.1893L21.3105 10.0603C21.0292 9.77907 20.6477 9.62109 20.25 9.62109C19.8523 9.62109 19.4708 9.77907 19.1895 10.0603L10.5 18.7498Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="editIconShadow"
          x="0"
          y="0"
          width="39"
          height="39"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.75" dy="3.75" />
          <feGaussianBlur stdDeviation="3.75" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default EditIcon;
